module.exports = __webpack_public_path__ + "img/cloud-meatball.5a2634ce.svg";